import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { Toaster } from "@/components/ui/sonner";
import { HelpWidget } from "@/components/HelpWidget";
import Login from "@/pages/Login";
import ResetPassword from "@/pages/ResetPassword";
import Dashboard from "@/pages/Dashboard";
import AdminConsole from "@/pages/AdminConsole";
import TechnicianAssist from "@/pages/TechnicianAssist";
import HyundaiPortal from "@/pages/HyundaiPortal";
import GMPortal from "@/pages/GMPortal";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
            <Route path="/admin" element={<ProtectedRoute adminOnly><AdminConsole /></ProtectedRoute>} />
            <Route path="/technician" element={<ProtectedRoute allowTech><TechnicianAssist /></ProtectedRoute>} />
            <Route path="/hyundai" element={<ProtectedRoute adminOnly><HyundaiPortal /></ProtectedRoute>} />
            <Route path="/gm" element={<ProtectedRoute adminOnly><GMPortal /></ProtectedRoute>} />
          </Routes>
        </BrowserRouter>
        <HelpWidget />
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
